module.exports = __webpack_public_path__ + "static/media/calendar.44e3bdfd.svg";